/* eslint-disable */
import React, { useState, useEffect }  from 'react'


// Services
import generateReportSvc from "services/generateReportSvc";
import applicationSvc from "services/applicationSvc";

// style
import './generateReport.scss';
import styled from 'styled-components';

// library
import moment from "moment";
import { useLocation } from 'react-router-dom';

// component
import Svg from "_assets/svg";
import H4 from 'components/H4';
import TitleV2 from 'components/TitleV2';
import H5 from 'components/H5';
import Wrapper from './Wrapper';
import Table from './TableData';
import ModalGenerate from './modalGenerate';
import FilterTable from './filter-table';

const ButtonExport = styled.button`
  /* Frame 57 */

  /* Auto Layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 15px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafd 100%);
  border: 1px solid #3B3B47;
  box-sizing: border-box;
  border-radius: 8px;
`;

const Icon = styled.img``;

function GenerateReport() {
  const location = useLocation();
  const [isLoadingGetList, setLoadingGetList] = useState(false)
  const [isDataUser, listDataUser] = useState([]);
  const [isPagination, setPagination]=useState({});
  const [isOpenModal, setOpenModal]=useState(false);
  const [isSearch, setSearch] = useState('');
  const [timer, setTimer] = useState(null)
  const [isListStatus, setListStatus] = useState([]);
  const [isUpdatedChange, setUpdatedChange] = useState(false);
  const [filter, setFilter] = useState (
    {
      "application_id": [],
      "channel": [],
      "start_date": '',
      "end_date": '',
      "type": [],
      "search": "",
      "limit": 10,
      "page": 1
    }
  )

useEffect(()=>{
  getAllData();
},[])

useEffect(()=>{
  if(location?.state?.showPopUp){
    handleShowModal()
  }
},[])

useEffect(() => {
  setListStatus([
    {
      name:'Done',
      value:'done',
    },
    {
      name:'Failed',
      value:'failed',
    },
    {
      name:'Preparation',
      value:'in-queue',
    },
    {
      name:'Processing',
      value:'onprogress',
    },
  ])
}, [])

useEffect( () => {
  delayedQuery()
}, [isUpdatedChange]);

 async function handleListReport(){
    listDataUser([])
    setLoadingGetList(true)
    if(filter.application_id.length > 0){
      await generateReportSvc.getListReport(filter)
     .then((res)=>{
  
      listDataUser(res.data.data)
      let paginate = {
       page : res.data?.page,
       limit : res.data?.limit,
       pages : res.data?.pages,
       total_all : res.data?.total,
      }
  
      setPagination(paginate)
      setLoadingGetList(false)
     })
     .catch((error)=>{
      console.log(error)
      setLoadingGetList(false)
     })
    }
}

async function getAllData() {
    setLoadingGetList(true)
    let res = await applicationSvc.getAll()
    if(res.data.data){
      let newFilter = filter;
      let data = []
      res?.data?.data.forEach(element => {
          data.push(element._id)
      });
      newFilter.application_id = data;
      setFilter(newFilter)
      handleListReport();
      setLoadingGetList(true)
    }
};

function changeCriteriaPaginationBar(data){
  let newFilter=filter
  newFilter.page = data.page;
  newFilter.limit = data.limit;
  setFilter(newFilter);
  handleListReport();
}

function handleShowModal(){
setOpenModal(true)
}

function refreshData(){
  handleListReport();
}

const delayedQuery = async () => {
  let newFilter=filter;
  newFilter.search=isSearch;
  newFilter.page=1;
  setFilter(newFilter);
  
  clearTimeout(timer)
  
  const newTimer = setTimeout(async() => {
    setLoadingGetList(true);
    await handleListReport();
    setLoadingGetList(false);
  }, 500)

  setTimer(newTimer)
}

  return (
    <Wrapper className="d-flex flex-column container-fluid no-pad" style={{height:'100%'}}>
      <ModalGenerate isOpenModal={isOpenModal} setOpenModal={setOpenModal} refreshData={refreshData}></ModalGenerate>
    <div className="d-flex flex-row align-items-start justify-content-between">
      <div className="d-flex flex-column">
        <TitleV2>Generate Report</TitleV2>
        <H4 className="margin-bottom-25">You can generate a hit rate report based on date range & status.</H4>
      </div>
      <div className='d-flex align-items-center'>
        <ButtonExport onClick={refreshData} className='mb-2 me-3'>
          <Icon className='margin-right-12' src={Svg.refreshinactive.default}/>
          <H5 className="fw-bold">
            Refresh
          </H5>
        </ButtonExport>
        <div onClick={handleShowModal} className='mb-2 btn-generate-report'>
          <span className='me-2'>+</span>
          <h5 className="fw-bold btn-generate">
            Generate New Report
          </h5>
        </div>
      </div>
    </div>
    <div className="d-flex flex-row justify-content-between align-items-center margin-bottom-20">
      <div className="d-flex flex-row align-items-center w-100">
       <FilterTable 
        isPagination={isPagination} 
        changeCriteria={changeCriteriaPaginationBar}
        searchKey={setSearch} 
        setUpdatedChange={setUpdatedChange} 
        isUpdatedChange={isUpdatedChange} 
        isListStatus={isListStatus} 
        isFilter={filter} 
        setFilter={setFilter}></FilterTable>
      </div>
    </div>
    <Table isDataUser={isDataUser} isLoadingGetList={isLoadingGetList} isPagination={isPagination} changeCriteria={changeCriteriaPaginationBar}/>
    </Wrapper>
  )
}

export default GenerateReport